import {SET_PADS_EXPAND} from 'constants/action-types.js';
import {SET_PADS} from 'constants/action-types.js';
import {SET_PAD_SLOTS} from 'constants/action-types.js';
import {SET_PAD_EFFECTS} from 'constants/action-types.js';
import {SET_SEQUENCERS} from 'constants/action-types.js';
import {SET_SEQUENCER_TRACKS} from 'constants/action-types.js';
import {SET_DRAWING_PAD_EDGE} from 'constants/action-types.js';
import {SET_MOVING_PAD_EDGE} from 'constants/action-types.js';
import {SET_SELECTED_PAD_EDGE} from 'constants/action-types.js';
import {SET_MODULE_COLLAPSED} from 'constants/action-types.js';
import {SET_TRACK_MIDI_EFFECTS} from 'constants/action-types.js';
import {SET_BULK_MODULES_COLLAPSED} from 'constants/action-types.js';
import {SET_PAD_FX_MODE} from 'constants/action-types.js';

let initialState = {
    modulesCollapsed: {},
    padEffects: {},
    drawingEdges: {},
    movingEdge: undefined,
    trackMidiEffects: {},
    padFXMode: {} // id -> mode
};
    
const padsReducer = (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case SET_PAD_FX_MODE:
        let {padFXMode} = state;
        padFXMode[action.payload.id] = action.payload.mode;
        return {
            ... state,
            padFXMode
        };
    case SET_MODULE_COLLAPSED:
        let modulesCollapsed = {... state.modulesCollapsed};
        modulesCollapsed[action.payload.id] = action.payload.collapsed;
        return {
            ... state,
            modulesCollapsed
        };
    case SET_BULK_MODULES_COLLAPSED:
        return {
            ... state,
            modulesCollapsed: action.payload
        };
    case SET_DRAWING_PAD_EDGE:
        let {drawingEdges} = state;
        drawingEdges[action.payload.id] = action.payload.edge;
        return {
            ... state,
            drawingEdges
        };
    case SET_MOVING_PAD_EDGE:
        return {
            ... state,
            movingEdge: action.payload
        };
    case SET_SELECTED_PAD_EDGE:
        return {
            ... state,
            selectedEdge: action.payload
        };
    case SET_SEQUENCERS:
        let sequencers = {... state.sequencers};
        sequencers[action.payload.id] = action.payload.sequencers;
        return {
            ... state,
            sequencers
        };
    case SET_SEQUENCER_TRACKS:
        let sequencerTracks = {... state.sequencerTracks};
        sequencerTracks[action.payload.id] = action.payload.tracks;
        return {
            ... state,
            sequencerTracks
        };
    case SET_PAD_SLOTS:
        let padSlots = {... state.padSlots};
        padSlots[action.payload.id] = action.payload.slots;
        return {
            ... state,
            padSlots
        };
    case SET_PADS_EXPAND:
        return {
            ... state,
            padsExpand: action.payload
        };
    case SET_PADS:
        let pads = {... state.pads};
        pads[action.payload.id] = action.payload.pads;
        return {
            ... state,
            pads
        };
    case SET_PAD_EFFECTS:
        let padEffects = state.padEffects;
        padEffects[action.payload.id] = action.payload.effects;
        return {
            ... state,
            padEffects: {... padEffects}
        };
    case SET_TRACK_MIDI_EFFECTS:
        let trackMidiEffects = state.trackMidiEffects;
        trackMidiEffects[action.payload.id] = action.payload.effects;
        return {
            ... state,
            trackMidiEffects: {... trackMidiEffects}
        };
    default:
        return state;
    }
};

export default padsReducer;
